export default "__VITE_ASSET__CRuuDcCg__"